import { el } from './dom.js';

export type StatusTone = 'waiting' | 'active' | 'success' | 'error';

export type StatusPill = Readonly<{
  element: HTMLElement;
  set: (tone: StatusTone, text: string) => void;
}>;

export const createStatusPill = (): StatusPill => {
  const dot = el('span', { className: 'status__dot' });
  const label = el('span', { className: 'status__label' });
  const element = el('div', { className: 'status status--waiting' }, [dot, label]);
  return {
    element,
    set: (tone, text) => {
      element.className = `status status--${tone}`;
      label.textContent = text;
    },
  };
};
